import styled from 'styled-components';

import { ANIM, COLORS, SPACE } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const Label = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

/**
 * The control wraps a native `<select>` (accessible + native mobile picker) so
 * the closed control matches `Field`'s inset look. `$invalid` reddens the border;
 * `$placeholder` dims the text while the empty placeholder option is selected.
 */
export const Control = styled.div<{ $invalid: boolean; $placeholder: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 12px;
  border: 1px solid ${(p) => (p.$invalid ? COLORS.statusDanger : COLORS.panelBorder)};
  background: ${COLORS.surfaceInset};
  transition: border-color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  /* The select drops the browser's outline, so its box says it has the focus. An invalid one stays red: the
     error is the louder of the two. */
  &:focus-within {
    border-color: ${(p) => (p.$invalid ? COLORS.statusDanger : COLORS.accent)};
  }

  select {
    flex: 1;
    min-width: 0;
    appearance: none;
    -webkit-appearance: none;
    border: none;
    outline: none;
    background: transparent;
    color: ${(p) => (p.$placeholder ? COLORS.textFaint : COLORS.text)};
    font-size: 16px;
    font-family: inherit;
    /* Right padding leaves room for the chevron. 14px: Field's block padding, so the two stand the same height
       (off the scale on purpose). */
    padding: 14px ${SPACE[40]} 14px ${SPACE[16]};
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    /* The open list paints with the OS palette on Windows/Linux — force a dark,
       readable list there (macOS uses its own picker and ignores this). */
    option {
      color: ${COLORS.text};
      background: ${COLORS.surfaceInset};
    }
  }
`;

export const Chevron = styled.svg`
  position: absolute;
  right: 14px;
  width: 12px;
  height: 12px;
  pointer-events: none;
  stroke: ${COLORS.textMuted};
  stroke-width: 2;
  fill: none;
`;

export const ErrorText = styled(Text)`
  font-size: 13px;
  color: ${COLORS.statusDanger};
`;
